var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AttributesAction, AttributesFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Attributes Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AttributesQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), attributesData = _c.attributesData, error_attributes = _c.error_attributes, loading = _c.loading, attributesFormData = _c.attributesFormData, success_attributes_form = _c.success_attributes_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        questionnaireTimer.startSection("Personal Attributes");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!attributesData || attributesData.length === 0) {
            dispatch(AttributesAction());
        }
    }, [dispatch]);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Personal Attributes");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(AttributesFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/confidence");
    };
    useEffect(function () {
        if (success_attributes_form && isSubmitting) {
            navigate("/questionnaire/qualifications");
        }
    }, [success_attributes_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Personal Attributes", content: "We are now focusing on your overall beliefs and self-assurance in getting ready for and exploring job opportunities.", data: attributesData, responses: attributesFormData, loading: !attributesData || attributesData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "attributes-w", width: getQuestionnaireProgressWidth("attributes", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default AttributesQuestionnaire;
